import { AmmConfig } from '../../features/data/apis/config-types';

export const amms: AmmConfig[] = [
  {
    id: 'polygon-quickswap',
    name: 'QuickSwap',
    type: 'uniswapv2',
    routerAddress: '0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff',
    factoryAddress: '0x5757371414417b8C6CAad45bAeF941aBc7d3Ab32',
    pairInitHash: '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '5',
    swapFeeNumerator: '3',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-cometh',
    name: 'Cometh',
    type: 'uniswapv2',
    routerAddress: '0x93bcDc45f7e62f89a8e901DC4A0E2c6C427D9F25',
    factoryAddress: '0x800b052609c355cA8103E06F022aA30647eAd60a',
    pairInitHash: '0x499154cad90a3563f914a25c3710ed01b9a43b8471a35ba8a66a056f37638542',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '9',
    swapFeeNumerator: '5',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', //router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-sushi',
    name: 'Sushi',
    type: 'uniswapv2',
    routerAddress: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    factoryAddress: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    pairInitHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '5',
    swapFeeNumerator: '3',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-wault',
    name: 'Wault',
    type: 'uniswapv2',
    routerAddress: '0x3a1D87f206D12415f5b0A33E786967680AAb4f6d',
    factoryAddress: '0xa98ea6356A316b44Bf710D5f9b6b4eA0081409Ef',
    pairInitHash: '0x1cdc2246d318ab84d8bc7ae2a3d81c235f3db4e113f4c6fdc1e2211a9291be47',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '2',
    swapFeeNumerator: '2',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-apeswap',
    name: 'ApeSwap',
    type: 'uniswapv2',
    routerAddress: '0xC0788A3aD43d79aa53B09c2EaCc313A787d1d607',
    factoryAddress: '0xCf083Be4164828f00cAE704EC15a36D711491284',
    pairInitHash: '0x511f0f358fe530cda0859ec20becf391718fdf5a329be02f4c95361f3d6a42d8',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '0.33333333333333333333333333333333', // (rootK / 3)
    swapFeeNumerator: '2',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-dyfn',
    name: 'DYFN',
    type: 'uniswapv2',
    routerAddress: '0xA102072A4C07F06EC3B4900FDC4C7B80b6c57429',
    factoryAddress: '0xE7Fb3e833eFE5F9c441105EB65Ef8b261266423B',
    pairInitHash: '0xf187ed688403aa4f7acfada758d8d53698753b998a3071b06f1b777f4330eaf3',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '5',
    swapFeeNumerator: '3',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint256 amountIn, uint256 reserveIn, uint256 reserveOut) pure returns (uint256 amountOut)
  },
  {
    id: 'polygon-jetswap',
    name: 'Jetswap',
    type: 'uniswapv2',
    routerAddress: '0x5C6EC38fb0e2609672BDf628B1fD605A523E5923',
    factoryAddress: '0x668ad0ed2622C62E24f0d5ab6B6Ac1b9D2cD4AC7',
    pairInitHash: '0x505c843b83f01afef714149e8b174427d552e1aca4834b4f9b4b525f426ff3c6',
    minimumLiquidity: '1000',
    mintFeeNumerator: '1',
    mintFeeDenominator: '5',
    swapFeeNumerator: '1',
    swapFeeDenominator: '1000',
    getAmountOutMode: 'getAmountOut', // router.getAmountOut(uint amountIn, uint reserveIn, uint reserveOut)
  },
  {
    id: 'polygon-dystopia',
    name: 'Dystopia',
    type: 'solidly',
    routerAddress: '0xbE75Dd16D029c6B32B7aD57A0FD9C1c20Dd2862e',
    factoryAddress: '0x1d21Db6cde1b18c7E47B0F7F42f4b3F68b9beeC9',
    pairInitHash: '0x009bce6d7eb00d3d075e5bd9851068137f44bba159f1cde806a268e20baaf2e8',
    minimumLiquidity: '1000',
    swapFeeNumerator: '1',
    swapFeeDenominator: '2000',
    getAmountOutMode: 'getAmountOut', // router.getExactAmountOut(uint amountIn, address tokenIn, address tokenOut, bool stable) -> pair.getAmountOut(uint256 amountIn, address tokenIn) view returns (uint256) OR router.getAmountsOut(uint amountIn, Route[] memory routes)
  },
];
